import { useEffect } from 'react';
import { debounce } from 'lodash-es';
import { generateClassName } from '@klv/shared/utils/functions';
import { calculateScrollPercent } from './utils/functions';

import * as s from './styles/scrollDepthIndicator.module.css';

export const ScrollDepthIndicator = ({
  className,
}: {
  className?: string;
}) => {
  
  useEffect(() => {
    const adjustIndicatorWidth = debounce(() => {
      document.documentElement.style.setProperty('--layout-scroll-depth-indicator-width', calculateScrollPercent());
    }, 30);
    adjustIndicatorWidth();
    window.addEventListener('scroll', adjustIndicatorWidth);

    return () => {
      window.removeEventListener('scroll', adjustIndicatorWidth);
    };
  }, []);

  return (
    <div
      className={generateClassName([className, s.scrollDepthIndicator])}
    />
  );
};
